import type { ComponentType } from 'react';
import { PermissionGate } from './PermissionGate';
import type { GrantedPermissionLevel } from './types';

/**
 * Obalí komponentu do {@link PermissionGate}. Vhodné pro registraci agend
 * v navigačním kernelu, kde se předává typ komponenty, ne element — bez
 * oprávnění (i při vstupu přes URL/historii) se místo obsahu zobrazí jednotná
 * hláška „Přístup odepřen". Výchozí úroveň `read` = zobrazení agendy.
 */
export function withPermissionGate<P extends object>(
  permission: string,
  Component: ComponentType<P>,
  minLevel: GrantedPermissionLevel = 'read'
): ComponentType<P> {
  function PermissionGated(props: P) {
    return (
      <PermissionGate permission={permission} minLevel={minLevel}>
        <Component {...props} />
      </PermissionGate>
    );
  }
  PermissionGated.displayName = `PermissionGated(${Component.displayName ?? Component.name ?? 'Component'})`;
  return PermissionGated;
}
